import { render, staticRenderFns } from "./DcjTimeliness.vue?vue&type=template&id=4c68d628&"
import script from "./DcjTimeliness.vue?vue&type=script&lang=ts&"
export * from "./DcjTimeliness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports